export default "__VITE_ASSET__DODxj41Q__"